import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tariffSummaryQueries } from '../queries/tariffSummaryQueries';
import { configureTariffSummaryAlert } from '../api/tariffSummaryApi';

export type AlertConfiguration = {
  dataThreshold: number | null;
  voiceThreshold: number | null;
  smsThreshold: number | null;
};

export type ConfigureTariffSummaryAlert = {
  tariffCodes: string[];
  alertConfiguration: AlertConfiguration;
};

export type UseTariffSummaryAlertConfigurationProps = {
  accountRef: string | null;
  onSuccess?: () => void;
  onError?: () => void;
};

export const useTariffSummaryAlertConfiguration = ({
  accountRef,
  onSuccess,
  onError,
}: UseTariffSummaryAlertConfigurationProps) => {
  const queryClient = useQueryClient();
  const { mutate: configureAlert, isPending } = useMutation({
    mutationFn: async (data: ConfigureTariffSummaryAlert) => {
      return configureTariffSummaryAlert(accountRef, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tariffSummaryQueries.all });
      onSuccess?.();
    },
    onError: () => {
      onError?.();
    },
  });

  return { configureAlert, isPending };
};
